import { apiClient } from './client'

export interface LoginRequest {
  username: string
  password: string
  keep_logged_in: boolean
}

export interface LoginResponse {
  access_token: string
  token_type: string
}

export interface AdminResponse {
  id: number
  username: string
  email: string | null
  is_active: boolean
  is_superuser: boolean
  last_login_at: string | null
}

export interface UpdateProfileRequest {
  email?: string
}

export interface ChangePasswordRequest {
  old_password: string
  new_password: string
}

export const authApi = {
  async login(username: string, password: string, keepLoggedIn: boolean): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/auth/login', {
      username,
      password,
      keep_logged_in: keepLoggedIn,
    })
    return response.data
  },

  async getCurrentUser(): Promise<AdminResponse> {
    const response = await apiClient.get<AdminResponse>('/auth/me')
    return response.data
  },

  async updateProfile(data: UpdateProfileRequest): Promise<AdminResponse> {
    const params = new URLSearchParams()
    if (data.email !== undefined) {
      params.append('email', data.email)
    }
    const response = await apiClient.patch<AdminResponse>(`/auth/me?${params.toString()}`)
    return response.data
  },

  async changePassword(data: ChangePasswordRequest): Promise<{ message: string }> {
    const params = new URLSearchParams()
    params.append('old_password', data.old_password)
    params.append('new_password', data.new_password)
    const response = await apiClient.post<{ message: string }>(`/auth/change-password?${params.toString()}`)
    return response.data
  },

  async logout(): Promise<void> {
    await apiClient.post('/auth/logout')
  },
}
